import React from 'react';

import { SearchBar } from '../../../../../shared/components/SearchBar';
import { useConversations } from '../../../hooks';
import ConversationsList from './ConversationsList';

const ConversationsPanel = () => {
  const {
    isLoadingList: isLoading,
    handleSearchChange,
    searchInput,
  } = useConversations();

  return (
    <div className="flex flex-col min-h-0">
      <div className="pt-1 px-3">
        <SearchBar
          disabled={isLoading}
          onChange={handleSearchChange}
          value={searchInput}
        />
      </div>

      <ConversationsList />
    </div>
  );
};

export default ConversationsPanel;
